import { Box, Icon, Text, Divider } from "@chakra-ui/react";
import { ReactComponent as ChangeraIcon } from "app/assets/svg/changera.svg";
import { ReactComponent as RoundIcon } from "app/assets/svg/roundIcon.svg";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { expandSideBar } from "app/store/action-creators/ui.action";
import {
  Bank,
  //Airplane,
  // Shop,
  //Notification,
  //MoneySend
  // Star,
  // Lovely
} from "iconsax-react";
import { useLayoutEffect } from "react";
import { BsCurrencyExchange } from "react-icons/bs";
import { MdFeaturedPlayList, MdOutlineFeaturedPlayList } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import {
  AppsOutlineIcon,
  AppsSolidIcon,
  CardOutlineIcon,
  CardSolidIcon,
  MessageOutlineIcon,
  MessageSolidIcon,
  ProfileCheckOutlineIcon,
  SettingsOutlineIcon,
  SettingsSolidIcon,
  StatusOutlineIcon,
  UsersIcon,
  WalletOutlineIcon,
  WalletSolidIcon,
} from "views/components/icons";
import { ReportSolidIcon } from "views/components/icons/report-solid-icon";
import { UserSolidIcon } from "views/components/icons/user-solid-icon";
import { UsersSolidIcon } from "views/components/icons/users-solid-icon";
import ListItem from "./components/list-item";

const menuSections = [
  {
    title: "Core Operations",
    items: [
      {
        url: "/dashboard",
        text: "Dashboard",
        icon: AppsOutlineIcon,
        icon2: AppsSolidIcon,
      },
      {
        url: "/requests",
        text: "Requests",
        icon: MessageOutlineIcon,
        icon2: MessageSolidIcon,
      },
    ],
  },
  {
    title: "Financial Management",
    items: [
      {
        url: "/wallets",
        text: "Wallets",
        icon: WalletOutlineIcon,
        icon2: WalletSolidIcon,
      },
      {
        url: "/virtual-accounts",
        text: "Virtual Accounts",
        icon: Bank,
        icon2: Bank,
      },
      {
        url: "/virtual-cards",
        text: "Virtual Cards",
        icon: CardOutlineIcon,
        icon2: CardSolidIcon,
      },
      {
        url: "/transactions",
        text: "Transactions",
        icon: CardOutlineIcon,
        icon2: CardSolidIcon,
      },
    ],
  },
  {
    title: "User Management",
    items: [
      {
        url: "/user-information",
        text: "User Information",
        icon: UsersIcon,
        icon2: UsersSolidIcon,
      },
      {
        url: "/verification",
        text: "Verification",
        icon: ProfileCheckOutlineIcon,
        icon2: UserSolidIcon,
      },
    ],
  },
  {
    title: "Analytics",
    items: [
      {
        url: "/reports",
        text: "Reports",
        icon: StatusOutlineIcon,
        icon2: ReportSolidIcon,
      },
    ],
  },
  {
    title: "Administration",
    items: [
      {
        url: "/exchange-rates",
        text: "Exchange Rates",
        icon: BsCurrencyExchange,
        icon2: BsCurrencyExchange,
      },
      {
        url: "/team-management",
        text: "Team Settings",
        icon: SettingsOutlineIcon,
        icon2: SettingsSolidIcon,
      },
      {
        url: "/feature",
        text: "Feature",
        icon: MdOutlineFeaturedPlayList,
        icon2: MdFeaturedPlayList,
      },
    ],
  },
];
// logout function from hooks

export interface CloseSideBar {
  onCloseSideBar?: () => void;
}

const Content = ({ onCloseSideBar }: CloseSideBar) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const closeSideNav = () => {
    if (!onCloseSideBar) return;
    onCloseSideBar();
  };

  const isCollapsed = useAppSelector((state) => state.UI.isCollapsed);

  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/");
  };

  useLayoutEffect(() => {
    const expandDesktopNav = () => {
      if (window.innerWidth <= 992) {
        dispatch(expandSideBar());
      }
    };
    window.addEventListener("resize", expandDesktopNav);

    return () => {
      window.removeEventListener("resize", expandDesktopNav);
    };
  }, []);

  return (
    <Box p={6} py={8} height="100%" overflowY="auto">
      <Box>
        {!isCollapsed ? (
          <Icon
            mb={8}
            ml={2}
            width="180px"
            height="16"
            as={ChangeraIcon}
            onClick={goToHome}
            cursor="pointer"
            transition="all 0.2s ease"
            _hover={{ transform: "scale(1.02)" }}
          />
        ) : (
          <Icon
            mb={8}
            boxSize="12"
            as={RoundIcon}
            p="2"
            onClick={goToHome}
            cursor="pointer"
            mx="auto"
            display="block"
            transition="all 0.2s ease"
            _hover={{ transform: "scale(1.1)" }}
          />
        )}

        <Box mt={6}>
          {menuSections.map((section, sectionIndex) => (
            <Box key={section.title} mb={6}>
              {!isCollapsed && (
                <Text
                  fontSize="xs"
                  fontWeight="600"
                  textTransform="uppercase"
                  letterSpacing="wider"
                  color="gray.500"
                  mb={3}
                  px={2}
                >
                  {section.title}
                </Text>
              )}
              {section.items.map((item) => (
                <ListItem
                  {...item}
                  key={item.text}
                  active={pathname === item.url}
                  onClick={closeSideNav}
                  isCollapsed={isCollapsed}
                />
              ))}
              {sectionIndex < menuSections.length - 1 && !isCollapsed && (
                <Divider my={4} borderColor="gray.200" opacity={0.3} />
              )}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
